import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Add } from '@factorialco/f0-react/icons/app'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import ImportEmployeesModal from 'modules/shift_management/components/ShiftManagement/ImportEmployeesModal'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'

const AddEmployeeRow = () => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')
  const [isEmployeesModalOpen, setIsEmployeesModalOpen] = React.useState<boolean>(false)

  return (
    <>
      <WrapperCell sticky minWidth="s240" noBorder height="fit-content">
        <Box background="grey000White" flexDirection="row" padding="s8">
          <Box flexDirection="row" alignItems="center" paddingY="s6">
            {newEntryFlowEnabled ? (
              <F0Button
                label={i18n.t('shift_management.import_employees.action')}
                variant="outline"
                icon={Add}
                onClick={() => setIsEmployeesModalOpen(true)}
              />
            ) : (
              <Button onClick={() => setIsEmployeesModalOpen(true)} type="secondary" iconName="add">
                {i18n.t('shift_management.import_employees.action')}
              </Button>
            )}
          </Box>
        </Box>
      </WrapperCell>

      {isEmployeesModalOpen && (
        <ImportEmployeesModal onClose={() => setIsEmployeesModalOpen(false)} />
      )}
    </>
  )
}

export default observer(AddEmployeeRow)
